const icon = require('vue-svgicon');
icon.register({
    'plus': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" d="M18.511 11.395h-7.115v7.116C11.396 19.33 10.77 20 10 20c-.771 0-1.397-.669-1.397-1.49v-7.116H1.49C.667 11.395 0 10.77 0 9.998c0-.77.667-1.396 1.49-1.396h7.114V1.488C8.604.665 9.23 0 10.001 0c.77 0 1.395.665 1.395 1.488v7.114h7.115c.822 0 1.489.625 1.489 1.396 0 .772-.666 1.397-1.489 1.397z" _fill="#9C9BA9"/>`,
    },
});
